export default function Legal({ doc }) {
  const CONTENT = {
    terms: {
      title: "Terms of Service",
      body: [
        "By purchasing an AuthorityOS diagnostic, you agree to these terms. The product is a one-time diagnostic report generated using automated scoring and AI-assisted narrative. It is not medical, psychological, legal, or financial advice.",
        "You are responsible for the accuracy of your responses. Reports are generated based on your inputs. Straight-line or non-responsive answers may be flagged in the report but do not entitle you to a refund.",
        "AuthorityOS retains generated reports server-side for support purposes. Raw questionnaire answers are not persisted. You may request deletion of your report by contacting support with your purchase ID.",
        "You may not resell, redistribute, or scrape the site's static content. The instrument, its wording, and its dimensions are proprietary.",
      ],
    },
    privacy: {
      title: "Privacy Policy",
      body: [
        "Data collected: email address, purchase ID, Stripe session ID, generated report, generated PDF. No raw questionnaire answers are stored on our servers.",
        "Cookies: an access cookie (24 hours, signed) is set after successful payment to admit you to the assessment. A minimal cookie stores your acknowledgement of this notice.",
        "Third parties: Stripe (payments), Anthropic Claude (report generation), Resend (email delivery). Data shared with these providers is limited to what is functionally necessary.",
        "Analytics: Meta Pixel and Conversions API may fire a purchase event on completed checkout. No profile of your responses is built. US market only.",
        "Retention: reports are retained for 24 months. You may request earlier deletion by contacting support with your purchase ID.",
      ],
    },
    refund: {
      title: "Refund Policy",
      body: [
        "AuthorityOS is a digital product. All sales are final. No refunds are issued once the diagnostic questionnaire has been started.",
        "You explicitly consent to this policy at checkout. If you have not started the questionnaire and believe the charge was made in error, contact support within 48 hours with your purchase ID.",
        "Chargebacks initiated without prior contact will be contested with evidence of consent at checkout and PDF delivery.",
        "Exceptions: technical failure preventing PDF delivery within 24 hours after questionnaire submission. In this case, support will regenerate and re-send at no charge.",
      ],
    },
  };
  const c = CONTENT[doc];
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 lg:py-24" data-testid={`legal-${doc}-page`}>
      <div className="eyebrow">Legal</div>
      <h1 className="mt-6 font-serif text-5xl lg:text-6xl text-[#1A1915] leading-[0.95]">{c.title}</h1>
      <div className="mt-12 space-y-6">
        {c.body.map((p, i) => (
          <p key={i} className="text-base text-[#1A1915] leading-relaxed">{p}</p>
        ))}
      </div>
      <div className="mt-16 eyebrow">Last updated · {new Date().toISOString().split("T")[0]}</div>
    </div>
  );
}
